module.exports = __webpack_public_path__ + "img/spouting-whale.c4e081fa.png";